<app-shared-action-bar [displayActionSectionBar]="false"></app-shared-action-bar>

<div class="wizard-page container p-4">
  <div class="mt-20 mb-4">
    @if (!selectedUser) {
      <p class="text-xs uppercase tracking-wide text-grey-700 mb-1">Users</p>
    }
    <h1 class="text-2xl font-semibold leading-tight">User Edit</h1>
    @if (!selectedUser) {
      <p class="text-sm text-grey-800">Select a user to update their settings.</p>
    }
  </div>

  @if (!selectedUser) {
    <div class="wizard-card shadow-sm">
      <div class="form-grid">
        <div class="form-row">
          <label>Select User</label>
          <p-select
            styleClass="w-full prime-input"
            [options]="userGroups"
            optionLabel="DisplayName"
            optionGroupLabel="label"
            optionGroupChildren="items"
            [group]="true"
            [filter]="true"
            filterBy="DisplayName,Username,Email"
            [showClear]="true"
            [disabled]="loadingUsers || loadError"
            [(ngModel)]="selectedUser"
            (onChange)="selectUser($event.value)"
            placeholder="Choose a user">
            <ng-template #group let-group>
              <div class="w-full border-b border-grey-500 pb-1 text-xs font-semibold uppercase tracking-wide text-grey-700">
                {{group.label}}
              </div>
            </ng-template>
            <ng-template #selectedItem let-user>
              <span>{{getUserOptionLabel(user)}}</span>
            </ng-template>
            <ng-template #item let-user>
              <div class="flex items-center justify-between w-full" [ngClass]="{'text-grey-900': !user.Active}">
                <span>{{user.DisplayName}}</span>
                @if (!user.Active) {
                  <span class="inactive-user-badge border border-grey-500 rounded-full text-grey-900 text-xs font-semibold px-2 py-1">Inactive</span>
                }
              </div>
            </ng-template>
          </p-select>
        </div>

        @if (loadingUsers) {
          <p class="text-grey-700">Loading users...</p>
        }
        @if (loadError) {
          <p class="text-danger-base">Unable to load users. Please try again.</p>
        }
      </div>
    </div>
  }

  @if (selectedUser) {
    <div class="mb-4 flex items-center gap-3">
      <p class="settings-selected-item">{{selectedUser.DisplayName}}</p>
      @if (!selectedUser.Active) {
        <span class="inactive-user-badge border border-grey-500 rounded-full text-grey-900 text-xs font-semibold px-2 py-1">Inactive</span>
      }
      <span (click)="clearSelection()" class="hover:cursor-pointer text-xl material-symbols-outlined">edit</span>
    </div>
    <div class="user-edit-tabs">
      <div class="tab"
        [ngClass]="{'active': activeTab === 1}"
        (click)="setActiveTab(1)">
        <span>Details</span>
      </div>
      <div class="tab"
        [ngClass]="{'active': activeTab === 2}"
        (click)="setActiveTab(2)">
        <span>Locations</span>
      </div>
      <div class="tab"
        [ngClass]="{'active': activeTab === 3}"
        (click)="setActiveTab(3)">
        <span>Permissions</span>
      </div>
      <div class="tab"
        [ngClass]="{'active': activeTab === 4}"
        (click)="setActiveTab(4)">
        <span>{{ 'audit' | customerTerm:true }}</span>
      </div>
    </div>
    <app-new-user-wizard
      [editMode]="true"
      [readOnlyMode]="readOnlyMode"
      [initialUser]="selectedUser"
      [tabMode]="true"
      [activeStep]="activeTab"
      [hideHeader]="true"
      (userDetailsSaved)="updateSelectedUser($event)"></app-new-user-wizard>
  }
</div>
